import styled from "styled-components";
import { Type } from "@ebscois/react-component-library";

export const StyledHeading = styled(Type)`
  padding-bottom: 0;
`;

export const ItalicType = styled(Type)`
  font-style: italic;
`;
